import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store/index';
import ApiPayment from '@/api/ApiPayment';
import {
  PaymentMethodCardListResponse,
  CreatePaymentMethodCardResponse,
  PaymentMethodListResponse,
} from '@API/src/component/home/payment/types';
import {
  FetchPaymentMethodRequest,
  PutPaymentMethodRequest,
  PostPaymentMethodCardRequest,
  DeletePaymentMethodCardRequest,
  FetchPaymentMethodCardRequest,
} from '@/model/Payment';
import { isTypeCard3dsChallengeResponse } from '@/model/TypeGuard/Payment';

export interface PaymentState {
  payments: PaymentMethodListResponse;
  cards: PaymentMethodCardListResponse;
}

@Module({ dynamic: true, store, name: 'payment', namespaced: true })
class PaymentModule extends VuexModule implements PaymentState {

  public payments: PaymentMethodListResponse = [];
  public cards: PaymentMethodCardListResponse = [];

  @Action({ rawError: true })
  public async fetchPaymentMethod(request: FetchPaymentMethodRequest) {
    try {
      const response: PaymentMethodListResponse = await ApiPayment.fetchPaymentMethod(request);
      this.setPayments(response);
      return response;
    } catch (error) {
      throw error;
    }
  }

  @Action({ rawError: true })
  public async putPaymentMethod(request: PutPaymentMethodRequest) {
    try {
      const response: PaymentMethodListResponse = await ApiPayment.putPaymentMethod(request);
      this.setPayments(response);
      return response;
    } catch (error) {
      throw error;
    }
  }

  @Mutation
  public setPayments(response: PaymentMethodListResponse) {
    this.payments = response;
  }

  /**
   * クレジットカードの新規登録
   *
   * バックエンドが3Dセキュアのチャレンジ認証を要求した場合、レスポンスは
   * { requires3ds: true, redirectUrl, accessPass } の形になる。
   * その場合はカード会社の認証画面へ画面遷移させ、accessPassを
   * sessionStorageに保持しておく（認証完了後の再送信で使用するため）。
   * 3Dセキュア不要、または認証確定後は通常のカード一覧が返る。
   */
  @Action({ rawError: true })
  public async postPaymentCardMethod(request: PostPaymentMethodCardRequest) {
    try {
      const response: CreatePaymentMethodCardResponse = await ApiPayment.postPaymentMethodCard(request);
      if (isTypeCard3dsChallengeResponse(response)) {
        sessionStorage.setItem('accessPass', response.accessPass);
        window.location.href = response.redirectUrl;
        return response;
      }
      this.setCards(response);
      return response;
    } catch (error) {
      throw error;
    }
  }

  @Action({ rawError: true })
  public async deletePaymentCardMethod(request: DeletePaymentMethodCardRequest) {
    try {
      const response: PaymentMethodCardListResponse = await ApiPayment.deletePaymentMethodCard(request);
      this.setCards(response);
      return response;
    } catch (error) {
      throw error;
    }
  }

  @Action({ rawError: true })
  public async fetchPaymentCardMethod(request: FetchPaymentMethodCardRequest) {
    try {
      const response: PaymentMethodCardListResponse = await ApiPayment.fetchPaymentMethodCard(request);
      this.setCards(response);
      return response;
    } catch (error) {
      throw error;
    }
  }

  @Mutation
  public setCards(response: PaymentMethodCardListResponse) {
    this.cards = response;
  }

}

export const paymentModule = getModule(PaymentModule);
